// extracted by mini-css-extract-plugin
module.exports = {"label":"HoursPerWeek_label__bAIR2","input":"HoursPerWeek_input__3qe_W"};